module.exports = __webpack_public_path__ + "static/media/icon-lead-won-color.fab1fefc.png";